module.exports = {
  linkResolver(doc) {
    if (doc.type === 'homepage') {
      return `/`;
    }

    return '/';
  },
};